import dayjs from 'dayjs';
import { PriorityTag, _Boolean } from '@/API';
import { UserAnnouncementType } from '@/appsync/graphql/userAnnouncement';
import { toLocaleDatetimeString } from '@/containers/globals/Util';
import { UserAnnouncement } from '@/types/type';
import { getFormattedDate, _BooleanEnum2boolean } from '@/utils/CommonUtils';

export const getStartDateTime = (seconds: number): number => {
  return dayjs
    .unix(seconds)
    .startOf('day')
    .unix();
};

export const getEndDateTime = (seconds: number): number => {
  return dayjs
    .unix(seconds)
    .startOf('day')
    .add(1, 'day')
    .subtract(1, 'second')
    .unix();
};

export const getTimeOfToday = () => {
  return dayjs()
    .startOf('day')
    .unix();
};

export const getTimeOfTomorrow = () => {
  return dayjs()
    .add(1, 'day')
    .startOf('day')
    .unix();
};

export const millisecondsToSeconds = (milliseconds: number) =>
  Math.floor(milliseconds / 1000);

export const isAfterToday = (seconds: number) => seconds >= getTimeOfToday();

export const canShow = ({
  isShow,
  displayStartDate,
  displayEndDate,
}: UserAnnouncementType): boolean => {
  return (
    _BooleanEnum2boolean(isShow) &&
    displayStartDate < getTimeOfTomorrow() &&
    (displayEndDate === 0 || displayEndDate >= getTimeOfToday())
  );
};

const getPriorityTagText = (priorityTag: PriorityTag): string => {
  switch (priorityTag) {
    case PriorityTag.High:
      return 'priorityTagHigh';
    case PriorityTag.Medium:
      return 'priorityTagMedium';
    case PriorityTag.Low:
      return 'priorityTagLow';
    default: {
      return '';
    }
  }
};

const getPriorityTagCss = (priorityTag: PriorityTag): string => {
  switch (priorityTag) {
    case PriorityTag.High:
      return 'high-priority';
    case PriorityTag.Medium:
      return 'medium-priority';
    case PriorityTag.Low:
      return 'low-priority';
    default: {
      return '';
    }
  }
};

const getAnnouncementUrl = (userAnnouncement: UserAnnouncementType): string => {
  return `${location.origin}/announcement/${userAnnouncement.announcementId}`;
};

export const convertUserAnnouncement = (
  userAnnouncement: UserAnnouncementType
): UserAnnouncement => {
  return {
    id: userAnnouncement.announcementId,
    isRead: _BooleanEnum2boolean(userAnnouncement.isRead),
    title: userAnnouncement.announcement.title,
    content: userAnnouncement.announcement.content,
    displayStartDate: getFormattedDate(userAnnouncement.displayStartDate),
    displayStartDateAsUpdateParam: userAnnouncement.displayStartDate,
    displayEndDate:
      userAnnouncement.displayEndDate === 0
        ? ''
        : getFormattedDate(userAnnouncement.displayEndDate),
    priorityTagText: getPriorityTagText(
      userAnnouncement.announcement.priorityTag
    ),
    priorityTagCss: getPriorityTagCss(
      userAnnouncement.announcement.priorityTag
    ),
    updatedAt: toLocaleDatetimeString(userAnnouncement.updatedAt),
    url: getAnnouncementUrl(userAnnouncement),
  };
};
